import {Card, styled} from '@mui/material';

const StyledCard = styled((props) => (
    <Card {...props} />
  ))(({ theme }) => ({
    padding: '20px',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '16px',
    border: '1px solid #415672',
    borderRadius: '20px',
    background: '#161d26',
    'h4': {
        fontWeight: 400,
        fontSize: '18px',
        letterSpacing: '0.2em',
        textTransform: 'uppercase'
    }
}));

export default StyledCard